module.exports = __webpack_public_path__ + "img/margaritaville-logo-header.e0efb3ae.png";